// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css - Design System Integration */
/* Base styles are now handled by design-system.css */
/* This file contains only app-specific overrides and utilities */

.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}

/* Legacy class support for backward compatibility */
.input-group {
  margin-bottom: 1.5rem;
}

.input-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: var(--text-primary);
  font-weight: 500;
}

.input-group input,
.input-group textarea,
.input-group select {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid var(--border-color);
  border-radius: 12px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: var(--card-bg);
  color: var(--text-primary);
}

.input-group input:focus,
.input-group textarea:focus,
.input-group select:focus {
  outline: none;
  border-color: var(--primary-light);
  box-shadow: 0 0 0 3px rgba(226, 232, 240, 0.25);
  background: rgba(15, 23, 42, 0.8);
}

.input-group input::placeholder,
.input-group textarea::placeholder {
  color: var(--text-light);
  opacity: 0.6;
}

/* Additional utility animations */
.fade-in {
  animation: fadeIn 0.5s ease-out;
}

.slide-in {
  animation: slideIn 0.3s ease-out;
}

.pulse {
  animation: pulse 2s infinite;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideIn {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC,qDAAqD;AACrD,iEAAiE;;AAEjE;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,oDAAoD;AACpD;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,qBAAqB;EACrB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;;EAGE,aAAa;EACb,kCAAkC;EAClC,+CAA+C;EAC/C,iCAAiC;AACnC;;AAEA;;EAEE,wBAAwB;EACxB,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF","sourcesContent":["/* App.css - Design System Integration */\n/* Base styles are now handled by design-system.css */\n/* This file contains only app-specific overrides and utilities */\n\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n/* Legacy class support for backward compatibility */\n.input-group {\n  margin-bottom: 1.5rem;\n}\n\n.input-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: var(--text-primary);\n  font-weight: 500;\n}\n\n.input-group input,\n.input-group textarea,\n.input-group select {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  background: var(--card-bg);\n  color: var(--text-primary);\n}\n\n.input-group input:focus,\n.input-group textarea:focus,\n.input-group select:focus {\n  outline: none;\n  border-color: var(--primary-light);\n  box-shadow: 0 0 0 3px rgba(226, 232, 240, 0.25);\n  background: rgba(15, 23, 42, 0.8);\n}\n\n.input-group input::placeholder,\n.input-group textarea::placeholder {\n  color: var(--text-light);\n  opacity: 0.6;\n}\n\n/* Additional utility animations */\n.fade-in {\n  animation: fadeIn 0.5s ease-out;\n}\n\n.slide-in {\n  animation: slideIn 0.3s ease-out;\n}\n\n.pulse {\n  animation: pulse 2s infinite;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(-100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
